/* eslint-disable ember/no-runloop */
import { assert } from '@ember/debug';
import type Owner from '@ember/owner';
import { later } from '@ember/runloop';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import Checkbox from 'ui-kit/components/changeset/checkbox';
import LabeledTextArea from 'ui-kit/components/changeset/labeled-text-area';

interface Args {
  changeset: EmberChangeset;
  defaultChatMessage: string;
  willSendMessage: boolean;
}

export default class ChatSendMessageForcComponent extends Component<Args> {
  static chatMessageKey = 'chatMessage';
  static willSendMessageKey = 'willSendMessage';

  chatMessageKey = ChatSendMessageForcComponent.chatMessageKey;
  willSendMessageKey = ChatSendMessageForcComponent.willSendMessageKey;

  constructor(owner: Owner, args: Args) {
    super(owner, args);
    this.#setupDefaultValues();
  }

  #setupDefaultValues = () => {
    assert(
      "A '@changeset' should be provided to the 'ChatSendMessageForcComponent'. It is in this changeset that the message will be written and then you could use the 'save-send-message' utils to save the message from the given changeset.",
      Boolean(this.args.changeset)
    );

    later(
      this,
      function () {
        this.args.changeset.set(
          this.chatMessageKey,
          this.args.defaultChatMessage
        );
        this.args.changeset.set(
          this.willSendMessageKey,
          this.args.willSendMessage
        );
      },
      500
    );
  };

  <template>
    <div class='grouped fields'>
      <div class='field'>
        <Checkbox
          @changeset={{@changeset}}
          @dataTestInput='willSendChatMessage'
          @labelName='Envoyer un message au patient'
          @payloadKey={{this.willSendMessageKey}}
        />
      </div>

      {{#if (changesetGet @changeset this.willSendMessageKey)}}
        <div class='field'>

          <LabeledTextArea
            @changeset={{@changeset}}
            data-test-send-chat-message='chatMessage'
            @propertyName={{this.chatMessageKey}}
            @rows={{4}}
          />
        </div>
      {{/if}}
    </div>
  </template>
}
